import { useState, useEffect } from 'react'

/**
 * useState seeded from localStorage, with write-through on change.
 * The key is global (not scoped per route); prefix it yourself if needed
 * (e.g. 'recordDetail:showFieldKeys').
 */
export function useLocalStorageState<T>(
  key: string,
  defaultValue: T
): [T, (value: T) => void] {
  const [state, setState] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(key)
      return raw !== null ? (JSON.parse(raw) as T) : defaultValue
    } catch {
      return defaultValue
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state))
    } catch {
      // quota exceeded or private-browsing restriction — silently ignore
    }
  }, [key, state])

  return [state, setState]
}
